import React, { HTMLProps } from 'react';
import { connect } from 'react-redux';
import { IAppState } from 'src/store';
import cn from 'classnames';
import { Text, View } from 'src/components/common';
import './styles.scss';

const UserDetailItem: React.FC<Props> = ({ label, text, className, ...props }) => {
  return (
    <View className={cn('cmp-detail-user-item', className)} {...props}>
      <Text className="cmp-detail-user-item__label">{label}</Text>
      <Text className="cmp-detail-user-item__text">{text ?? '--'}</Text>
    </View>
  );
};

type Props = ReturnType<typeof mapStateToProps> &
  typeof mapDispatchToProps &
  HTMLProps<HTMLDivElement> & {
    label: string;
    text: string;
  };

const mapStateToProps = (state: IAppState) => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(UserDetailItem);
